import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./ClaimNumberLabel.module.scss";

interface Props {
  currentClaimNumber?: string | null;
}

const ClaimNumberLabel = ({ currentClaimNumber }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.value}>
      <span className={styles.label}>{t("transactions.details.claimNumber.label")}ㅤ</span>
      <span>{currentClaimNumber || t("empty")}</span>
    </div>
  );
};

export default ClaimNumberLabel;
